import type { ButtonProps } from '@heroui/react';

import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, cn, Switch } from '@heroui/react';

interface Props {
  className?: string;
  isDarkMode: boolean;
  isSwitchOnly?: boolean;
  size?: ButtonProps['size'];
  toggleDarkMode: () => void;
}

export function DarkModeToggle({
  className = '',
  isDarkMode,
  isSwitchOnly = false,
  size = 'sm',
  toggleDarkMode,
}: Props) {
  return isSwitchOnly ? (
    <Switch
      className={className}
      classNames={{ wrapper: cn`mr-0` }}
      defaultSelected={isDarkMode}
      onChange={toggleDarkMode}
    />
  ) : (
    <Button
      className={className}
      isIconOnly
      onPress={toggleDarkMode}
      size={size}
      variant="flat"
    >
      {isDarkMode ? (
        <FontAwesomeIcon icon={faSun} />
      ) : (
        <FontAwesomeIcon icon={faMoon} />
      )}
    </Button>
  );
}
